const REPLAY_COPY_PREFIX = /^Replay: /

export default function retakeDeckTitle(presentation) {
  return (presentation?.name || '').replace(REPLAY_COPY_PREFIX, '').trim()
}
